import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { Form } from 'semantic-ui-react'
import { FarmersService } from '~/api/services/farmers'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { useAuth } from '~/routes/components/AuthProvider'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'

const MilkTypes: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const lightUserLogged = roleSlug === LIGHT_USER_ROLE_SLUG

  const [isBusy, setIsBusy] = useState(false)
  const [milkTypeId, setMilkTypeId] = useState<Nullable<number>>(null)

  const {
    data: milkTypeData,
    isLoading: isLoadingMilkType
  } = FarmersQuery.getFarmerMilkType(id)

  const {
    data: milkTypeOptions,
    isLoading: isLoadingOptions
  } = FarmersQuery.getFarmerMilkTypeOptions(id)

  useEffect(() => {
    if (!isLoadingMilkType && milkTypeData) {
      setMilkTypeId(milkTypeData.milkTypeId)
    }
  }, [milkTypeData, isLoadingMilkType])

  async function handleUpdate() {
    setIsBusy(true)
    try {
      await FarmersService.updateMilkTypes(id, { milkTypeId })
      notify(t('Successfully updated milke type'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton
        disabled={isBusy || !milkTypeId}
        onClick={() => handleUpdate()}
      >{t('Update')}</El.PageHeaderActionButton>
    </>
  }

  return <Layout
    title={''}
    childContainerSize={'auto'}
    useSpinner
    isBusy={isBusy || isLoadingMilkType || isLoadingOptions}
    childrenOverflow={'visible'}
    actions={!lightUserLogged && renderActions()}
  >
    <Form style={{ height: 200 }}>
      <Form.Dropdown
        selection
        value={milkTypeId}
        scrolling
        selectOnBlur={false}
        onChange={(_, data) => setMilkTypeId(data.value as number)}
        label={t('Milk type')}
        options={milkTypeOptions?.milkTypes?.map(milkType => ({ text: milkType.name, value: milkType.milkTypeId })) || []}
        placeholder={t('Please select milk type')}
      />
    </Form>
  </Layout>
}
export default MilkTypes